export default __webpack_public_path__ + "static/media/payment_fail.404e4f5b.svg";